/**
 * Seo component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'
import { useLocation } from '@reach/router'
import favicon from '../images/CELERITY-favicon.png'

const Seo = ({ title, description, image, breadcrumbs, props }) => {
    const { wp, site } = useStaticQuery(graphql`
        query {
            wp {
                generalSettings {
                    title
                    description
                }
                acfOptionsHeader {
                    featuredImage {
                        image {
                            sourceUrl
                            resize(width: 1200) {
                                src
                            }
                        }
                    }
                }
                siteSettings {
                    globalMeta {
                        robotMeta
                    }
                }
            }
            site {
                siteMetadata {
                    title
                    description
                    author
                    siteUrl
                    og {
                        siteName
                        fbTitle
                        fbDescription
                        twitterCreator
                        twitterDescription
                    }
                }
            }
        }
    `)

    const location = useLocation()
    const canonicalUrl = `${site?.siteMetadata?.siteUrl}${location.pathname}`
    const featuredImage = wp?.acfOptionsHeader?.featuredImage?.image?.sourceUrl
    const keywords = props?.focuskw.replaceAll('|', ',').replaceAll(' ,', ', ')
    const seo = {
        title: title || wp?.generalSettings?.title,
        description: description || `${wp?.generalSettings?.description}`,
        keywords: keywords || title,
        ogImage: image || featuredImage,
        noIndex: wp?.siteSettings?.globalMeta?.robotMeta
    }

    const metas = [
        {
            name: 'icon',
            content: `${site?.siteMetadata?.siteUrl}/images/CELERITY-favicon.png`
        },
        {
            name: 'description',
            content: seo.description
        },
        {
            name: 'keywords',
            content: seo.keywords
        },
        {
            name: 'twitter:card',
            content: 'summary_large_image'
        },
        {
            name: 'twitter:description',
            content: seo.description || props?.twitterDescription
        },
        {
            name: 'twitter:title',
            content: seo.title || props?.twitterTitle
        },
        {
            name: 'twitter:image',
            content: seo.ogImage
        },
        {
            name: 'twitter:creator',
            content: site?.siteMetadata?.og?.twitterCreator
        }
    ]
    const ogMetas = [
        {
            name: 'og:image',
            content: seo.ogImage
        },
        {
            name: 'og:type',
            content: 'website'
        },
        {
            name: 'og:title',
            content: seo.title || props?.opengraphTitle + ' - Celerity'
        },
        {
            name: 'og:description',
            content: seo.description || props?.opengraphDescription
        },
        {
            name: 'og:site_name',
            content: site?.siteMetadata?.og?.siteName
        },
        {
            name: 'og:url',
            content: `${site?.siteMetadata?.siteUrl}${location.pathname}`
        }
    ]
    return (
        <>
            <title>{seo.title}</title>
            {metas.map((meta) => (
                <meta key={meta.name} name={meta.name} content={meta.content} />
            ))}
            {ogMetas.map((meta) => (
                <meta
                    key={meta.name}
                    property={meta.name}
                    content={meta.content}
                />
            ))}
            {/* page,post level */}
            {props?.metaRobotsNofollow === 'nofollow' && (
                <meta
                    name="robots"
                    content="noindex, nofollow"
                    scope="page,post"
                />
            )}
            {/* global level */}
            {seo.noIndex && (
                <meta
                    name="robots"
                    content="noindex, nofollow"
                    scope="global"
                />
            )}
            <link rel="canonical" href={seo.canonical || canonicalUrl} />
            <script type="application/ld+json">
                {JSON.stringify(breadcrumbs)}
            </script>
        </>
    )
}

Seo.defaultProps = {
    lang: `en`,
    meta: [],
    description: ``
}

Seo.propTypes = {
    seo: PropTypes.object
}

export default Seo
